import QuoteForm from "@/components/site/QuoteForm";
import { ShieldCheck, Clock, BadgeIndianRupee } from "lucide-react";

export default function QuotePage() {
  return (
    <div className="py-16 lg:py-24 bg-slate-50 min-h-[80vh]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="text-sm font-semibold tracking-[0.18em] uppercase text-[#081537] mb-3">Request a Private Consultation</div>
          <h1 className="font-[Outfit] text-4xl sm:text-5xl font-bold tracking-tight text-[#0F172A] text-balance">
            Get a free, transparent moving quote.
          </h1>
          <p className="mt-5 text-lg text-slate-600 leading-relaxed">
            Fill in the details below. Our coordinator will review and get back to you with an itemized quotation within 2 hours.
          </p>

          <div className="mt-8 space-y-4">
            {[
              { Icon: BadgeIndianRupee, title: "Transparent pricing", desc: "Itemized quote with no hidden charges." },
              { Icon: Clock, title: "Quick turnaround", desc: "Quotation within 2 hours, 7 days a week." },
              { Icon: ShieldCheck, title: "Insured & safe", desc: "Transit insurance on every shipment." },
            ].map(({ Icon, title, desc }) => (
              <div key={title} className="flex gap-4 bg-white rounded-xl p-4 border border-slate-100">
                <div className="w-11 h-11 rounded-lg bg-slate-100 text-[#081537] grid place-items-center flex-shrink-0">
                  <Icon className="w-5 h-5" />
                </div>
                <div>
                  <div className="font-semibold text-[#0F172A]">{title}</div>
                  <div className="text-sm text-slate-600">{desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-7">
          <QuoteForm />
        </div>
      </div>
    </div>
  );
}
